import { Button } from '@nextui-org/react'
import {
  ControlledCheckbox,
  ControlledCheckboxGroup,
  ControlledEmailInput,
} from '@shared/components/controlled-fields'
import { __ } from '@wordpress/i18n'
import { useForm } from 'react-hook-form'

import { emailRegex } from '../lib/util'

export type FormState = {
  accept_privacy_policy: boolean
  brand: string[]
  email: string
}

const defaultValues: FormState = {
  accept_privacy_policy: false,
  brand: [],
  email: '',
}

const brandOptions = [
  {
    label: 'ASAVA',
    value: 'ASAVA',
  },
  {
    label: 'asv',
    value: 'asv',
  },
]

export interface SubscriptionPopupFormProps {
  onSubmit: (data: FormState) => void
}

export function SubscriptionPopupForm({
  onSubmit,
}: SubscriptionPopupFormProps) {
  const {
    control,
    formState: { isSubmitting },
    handleSubmit,
  } = useForm<FormState>({
    defaultValues,
    mode: 'onBlur',
  })

  return (
    <>
      <div className="relative">
        <form className="space-y-6" onSubmit={handleSubmit(onSubmit)}>
          <ControlledCheckboxGroup
            control={control}
            fieldProps={{
              classNames: {
                wrapper: 'justify-center gap-4',
              },
              orientation: 'horizontal',
            }}
            name="brand"
            options={brandOptions}
          />
          <ControlledEmailInput
            control={control}
            fieldProps={{
              classNames: {
                input: 'placeholder:uppercase',
                inputWrapper: 'border-primary',
                label: 'uppercase',
              },
              label: __('Email Address', 'asavagroup'),
              type: 'email',
              variant: 'bordered',
            }}
            name="email"
            rules={{
              pattern: {
                message: 'Please enter a valid email address',
                value: emailRegex,
              },
              required: 'Please enter your email address',
            }}
          />
          <ControlledCheckbox
            control={control}
            fieldProps={{
              classNames: {
                label: 'text-xs uppercase',
              },
            }}
            label="I agree to receive marketing, advertising and promotional communications from the asava group in relation to the asava group activities and acknowledge that I can opt out at any time."
            name="accept_privacy_policy"
            rules={{
              required: 'Please accept the privacy policy',
            }}
          />
          <Button
            color="primary"
            fullWidth
            isLoading={isSubmitting}
            size="lg"
            type="submit"
            variant="solid"
          >
            {__('Subscribe', 'asavagroup')}
          </Button>
        </form>
      </div>
    </>
  )
}

export default SubscriptionPopupForm
